export default __webpack_public_path__ + "static/media/wanna4.18d69563.webp";